import delay from 'yoctodelay';
export default async function pMinDelay(promise, minimumDelay) {
  let {
    delayRejection = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  await Promise[delayRejection ? 'allSettled' : 'all']([promise, delay(minimumDelay)]);
  return promise;
}